var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBuilding = function SvgBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 140,
    viewBox: "0 0 136 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 64.5001V25.7251C90.5 21.7501 88.925 17.9251 86.075 15.1501L73.25 2.3251C70.325 -0.599902 65.6 -0.599902 62.675 2.3251L49.925 15.0751C47.075 17.9251 45.5 21.7501 45.5 25.7251V34.5001H15.5C7.25 34.5001 0.5 41.2501 0.5 49.5001V124.5C0.5 132.75 7.25 139.5 15.5 139.5H120.5C128.75 139.5 135.5 132.75 135.5 124.5V79.5001C135.5 71.2501 128.75 64.5001 120.5 64.5001H90.5ZM30.5 124.5H15.5V109.5H30.5V124.5ZM30.5 94.5001H15.5V79.5001H30.5V94.5001ZM30.5 64.5001H15.5V49.5001H30.5V64.5001ZM75.5 124.5H60.5V109.5H75.5V124.5ZM75.5 94.5001H60.5V79.5001H75.5V94.5001ZM75.5 64.5001H60.5V49.5001H75.5V64.5001ZM75.5 34.5001H60.5V19.5001H75.5V34.5001ZM120.5 124.5H105.5V109.5H120.5V124.5ZM120.5 94.5001H105.5V79.5001H120.5V94.5001Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building.50097e99.svg";
export { ForwardRef as ReactComponent };